import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
    selector: 'sst-graph-axis',
    templateUrl: './sst-graph-axis.component.html',
    styleUrls: ['./sst-graph-axis.component.css']
})

export class SSTGraphAxisComponent implements OnInit, OnChanges {

    @Input() axisQuestions: any[];
    @Input() axisUserProfile: any[];
    @Input() graphGenerated: boolean = false;
    @Input() startOver: boolean = false;
    @Output() axisData: EventEmitter<any> = new EventEmitter();
    @Output() resetAxis: EventEmitter<any> = new EventEmitter();
    @Input()
    type: string;
    @Input()
    filteredYAxisIds: any[]

    disableApply: boolean = true;
    selectedQuestion:any = {};
    selectedProfileData:any = {};

    constructor(
    ) { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['startOver']) {
            if(this.startOver){
                this.resetFilter();
            }
        }
    }

    questionSelection(selectedQuestion, choiceItem) {
            // this._checkForMultiSelection(this.axisUserProfile, 'userProfileData', true);
            this._checkForMultiSelection(this.axisQuestions, 'choices', true, selectedQuestion, choiceItem);
            this.disableApply = this._checkDisableApply();
            this.selectedQuestion = selectedQuestion;
           // this.selectedProfileData = {};
            this.apply();
    }

    userProfileDataSelection(selectedProfile, choiceItem) {
            // this._checkForMultiSelection(this.axisQuestions, 'choices', true);
            this._checkForMultiSelection(this.axisUserProfile, 'userProfileData', true, selectedProfile, choiceItem);
            this.disableApply = this._checkDisableApply();
            this.selectedProfileData = selectedProfile;
            this.apply();
            //this.selectedQuestion = {};
    }

    resetFilter() {
        this._checkForMultiSelection(this.axisQuestions, 'choices', true);
        this._checkForMultiSelection(this.axisUserProfile, 'userProfileData', true);
        // this.disableApply = true;
        this.resetAxis.emit(this.type);
    }

    filterApply() {
        this.disableApply = true;
        this.axisData.emit({
            isApplied:true,
            question: this.selectedQuestion,
            questionSelected: this._checkOptionSelected(this.axisQuestions, 'choices'),
            userProfile: this.selectedProfileData,
            profileSelected :this._checkOptionSelected(this.axisUserProfile, 'userProfileData')
        });
    }
    /**
     * @description apply data when selection
     */
    apply() {
      this.disableApply = false;
      this.axisData.emit({
          isApplied:false,
          question: this.selectedQuestion,
          questionSelected: this._checkOptionSelected(this.axisQuestions, 'choices'),
          userProfile: this.selectedProfileData,
          profileSelected :this._checkOptionSelected(this.axisUserProfile, 'userProfileData')
      });
  }

    _checkDisableApply(){
        if (this._checkOptionSelected(this.axisQuestions, 'choices') ||
            this._checkOptionSelected(this.axisUserProfile, 'userProfileData')) {
                return false;
        }else{
            return true;
        }
    }

    _checkOptionSelected(array, key) {
        return array.some(item => this._checkSubOptionSelected(item[key]) == true);
    }

    _checkSubOptionSelected(options) {
        return options.some(option => option.selected == true);
    }

    _checkForMultiSelection(array, key, reset, selectedData?, selectedChoice?) {
        array.forEach(profile => {
            if ((!selectedData || profile.id != selectedData.id) && reset) {
                profile[key].forEach(choice => {
                    choice.selected = false;
                })
                profile.selected = false;
            } else {
                profile[key].forEach(choice => {
                    if (choice.id == selectedChoice.id)
                        choice.selected = !choice.selected;
                })
                if(this._checkSubOptionSelected(profile[key]))
                    profile.selected = true;
                else
                    profile.selected = false;
            }
        });
    }
    isDisabled(quetionId){
    if(this.filteredYAxisIds.length>0){
      const yFilterIndex = this.filteredYAxisIds.findIndex(x=>x === quetionId);
      return yFilterIndex>-1 && this.filteredYAxisIds.length>0? false:true;
      }else{
        return false;
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-axis/sst-graph-axis.component.ts